<div class="alert-preview__header">
  <span class="alert-preview__icon-badge">
    <mat-icon class="material-symbols-outlined">visibility</mat-icon>
  </span>
  <div class="alert-preview__heading">
    <h2 mat-dialog-title class="alert-preview__title">End-user preview</h2>
    <p class="alert-preview__subtitle">{{ visibleAlerts.length }} live alerts · exactly what a user sees right now</p>
  </div>
  <button type="button" class="alert-preview__close" mat-dialog-close aria-label="Close">
    <mat-icon class="material-symbols-outlined">close</mat-icon>
  </button>
</div>

<mat-dialog-content class="alert-preview__content">
  <!-- A simulated end-user dashboard behind the toast stack — never a real page, just enough of
       the app's own look (red "» OVERVIEW" nav bar + placeholder content blocks) to sell "this is
       what floats over the page a user is on", per the design. -->
  <div class="alert-preview__viewport">
    <div class="alert-preview__viewport-bar">
      <span class="sgl-arrows sgl-arrows--lg" aria-hidden="true"></span>
      OVERVIEW
    </div>
    <div class="alert-preview__viewport-body">
      <div class="alert-preview__placeholder-grid">
        <div class="alert-preview__placeholder-card"></div>
        <div class="alert-preview__placeholder-card"></div>
        <div class="alert-preview__placeholder-bar"></div>
        <div class="alert-preview__placeholder-row"></div>
        <div class="alert-preview__placeholder-row"></div>
        <div class="alert-preview__placeholder-row"></div>
        <div class="alert-preview__placeholder-row"></div>
      </div>
      <div class="alert-preview__toast-stack">
        <app-alert-preview-stack
          [loading]="loading"
          [hasError]="hasError"
          [alerts]="visibleAlerts"
          (dismiss)="dismiss($event)"></app-alert-preview-stack>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="alert-preview__actions">
  <p class="alert-preview__note">Alerts never auto-dismiss and never block the page.</p>
  <button type="button" class="alert-preview__close-btn" mat-stroked-button mat-dialog-close>Close</button>
</mat-dialog-actions>
